import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { PhoneOutgoing, PhoneIncoming } from "lucide-react";

// Capture a client touch on a bid. Inbound replies drive the follow-up nudge.
export function ContactDialog({ bidId, bidName, open, onOpenChange, onDone }) {
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  const log = async (direction) => {
    setSaving(true);
    try {
      await api.post(`/bids/${bidId}/contact`, { direction, note: note.trim() });
      toast.success(direction === "in" ? "Logged their reply" : "Logged your outreach");
      setNote("");
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not log contact");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="contact-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Log contact — {bidName}</DialogTitle>
          <DialogDescription>
            Recording a reply from the client clears the follow-up nudge. Recording your outreach resets the clock.
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label className="text-xs">Note (optional)</Label>
          <Textarea data-testid="contact-note" rows={3} value={note} onChange={(e) => setNote(e.target.value)}
            placeholder="What was said? e.g. PM confirmed award decision by end of month." />
        </div>
        <DialogFooter className="flex-wrap gap-2">
          <Button data-testid="contact-out-btn" variant="outline" disabled={saving} onClick={() => log("out")}>
            <PhoneOutgoing className="w-4 h-4 mr-1.5" /> We reached out
          </Button>
          <Button data-testid="contact-in-btn" disabled={saving} onClick={() => log("in")}
            className="bg-[#003E87] hover:bg-[#00305F] text-white">
            <PhoneIncoming className="w-4 h-4 mr-1.5" /> They replied
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
